import { createStore } from "vuex";
import userModule from "./modules/user";
import globalApis from "./modules/store";
import ssoModule from "./modules/sso";
import createPersistedState from "vuex-persistedstate"

const store = createStore({
  modules: {
    user: userModule,
    globalApis: globalApis,
    sso: ssoModule,
  },
  strict: false,
  plugins: [
    createPersistedState({
      key: 'connector/v1.0',
    }),
  ],
});
export default store;
